const zIndexes = {
  normal: '100',
  modal: '200',
  modalForeground: '300'
};

export { zIndexes };
